import React from "react"
import { withStyles } from '@material-ui/core';
import { CSVLink } from 'react-csv'
import Icon from "storybookComponents/Icon"

const styles = () => ({
  root: {
    height: 60,
    padding: "12px 16px",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #dadada",
    borderBottom: "0px",
    fontFamily: "Open Sans"
  },
  title: {
    fontSize: 24,
    lineHeight: "36px",
    color: "rgba(0, 0, 0, 1)"
  },
  rightContainer: {
    display: "flex",
    alignItems: "center",
  },
  rightText: {
    height: 32,
    padding: "6px 16px",
    color: "rgba(79, 111, 174, 1)",
    fontFamily: 'Open Sans',
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    "&:hover": {
      color: "#26bbed"
    }
  },
  filterEnableClass: {
    background: "rgba(38, 187, 237, 0.06)",
  },
  filterClass: {
    height: 24,
    width: 24,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 16
  },
})


const TableHeader = ({ classes, title, fileName, csvData, csvHeaders, handleShowFilter, showFilter }) => {
  return (
    <div className={classes.root}>
      <div className={classes.title}>{title}</div>
      <div className={classes.rightContainer}>
        <CSVLink filename={fileName} data={csvData} headers={csvHeaders}>
          <span className={classes.rightText}>Export CSV</span>
        </CSVLink>
        <div onClick={handleShowFilter} className={`${showFilter && classes.filterEnableClass} ${classes.filterClass}`}>
          <Icon type="icon-filter-tool" size="sm" />
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(TableHeader)